import { useEffect, useState } from "react"
import { useLocation, Link } from "react-router-dom"
import Buscador from "../../Buscador/Buscador"
import Cardsimple from "../../cards/Cardsimple"
import LoaderEquipment from "../../loaders/LoaderEquipment"
import Pagination from "../../pagination/Pagination"
import Topnavbar from "../../sections/Topnavbar"
import getAllEquipment from "../../services/equipment/getAllEquipment"
import Tableinventario from "./Tableinventario"
import { Helmet, HelmetProvider } from "react-helmet-async"
import Leftnavbar from "../../sections/Leftnavbar"
import Footerbar from "../../sections/Footerbar"

const Inventario = () => {
    const { search } = useLocation()
    const query = new URLSearchParams(search)

    const busqueda = query.get("bus") || ""
    const paginaURL = query.get("pag") || 1
    const filtro = query.get("fil") || ""

    const [equipment, setEquipment] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        getAllEquipment(busqueda, paginaURL)
            .then((data) => {
                window.scrollTo(0, 0)
                setEquipment(data)
            })
            .catch(() => setError("Error al cargar el inventario"))
    }, [busqueda, paginaURL])

    const totalResultados = equipment?.tResultados || 0
    const totalPaginas = equipment?.tPaginas || 1
    const tamanioPagina = equipment?.taPagina || 1
    const paginaAPI = equipment?.pActual || 1
    const Titulo = busqueda ? busqueda.charAt(0).toUpperCase() + busqueda.slice(1) : ""

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>INVENTARIO {busqueda && ` : ${Titulo}`}</title>
                </Helmet>
            </HelmetProvider>
            <Leftnavbar />
            <Topnavbar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-10">
                                <h1 className="m-0">Inventario {busqueda && `: ${Titulo}`}</h1>
                            </div>
                            <div className="col-lg-2">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active">Inventario</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <Cardsimple
                                    header={
                                        <div className="row">
                                            <div className="col-md-8">
                                                <Buscador
                                                    dataBusqueda={busqueda}
                                                    dataPagina="inventario"
                                                    filtroValue={filtro}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Pagination
                                                    busqueda={busqueda}
                                                    page="inventario"
                                                    pagActual={paginaURL}
                                                    pagAPI={paginaAPI}
                                                    totalPaginas={totalPaginas}
                                                />
                                            </div>
                                        </div>
                                    }
                                />

                                {error && <div className="alert alert-danger">{error}</div>}

                                {!equipment ? (
                                    <LoaderEquipment />
                                ) : (
                                    <Cardsimple
                                        condensed
                                        footer={
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="p-1">
                                                        Resultados de la búsqueda: {totalResultados}
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Pagination
                                                        busqueda={busqueda}
                                                        page="inventario"
                                                        pagActual={paginaURL}
                                                        pagAPI={paginaAPI}
                                                        totalPaginas={totalPaginas}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    >
                                        <Tableinventario datos={equipment} />
                                    </Cardsimple>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footerbar />
        </>
    )
}
export default Inventario
